<p-card styleClass="flex w-full h-full p-4">
  <ng-template pTemplate="header">
    <div class="flex justify-between items-center">
      <h2>All Scheduled Activities</h2>
      <app-icon-button 
        *ngIf="showAddActivityButton"
        [icon]="icons.solid.faCirclePlus" 
        textSize="text-lg" 
        [pTooltip]="'Create an Activity'" 
        [showDelay]="500"
        (click)="addActivity()">
      </app-icon-button>
    </div>
  </ng-template>

  @if (loading()) {
    <p-progress-spinner styleClass="flex justify-center w-16 h-16"></p-progress-spinner>
  } @else {
    @if (activities().length === 0) {
      <div class="flex justify-center items-center p-4">
        <p class="text-gray-500">You have no scheduled activities</p>
      </div>
    } @else {
      <p-table #table
        [stripedRows]="true"
        [paginator]="true" 
        [rows]="10"
        [rowsPerPageOptions]="[10, 20, 50]"
        [value]="activities()" 
        styleClass="p-datatable-gridlines" 
        [tableStyle]="{'min-width': '50rem'}"
        [globalFilterFields]="globalFilterFields">
        <ng-template pTemplate="caption">
          <app-table-caption [table]="table" [showColumnSelector]="false" [showExportButtons]="false" [showClearFilters]="true"></app-table-caption>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <app-table-headers [columns]="columns()"></app-table-headers>
            <th>Actions</th>
            
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-activity>
          <tr>
            <app-table-columns [columns]="columns()" [data]="activity"></app-table-columns>
            <td class="text-center">
              @if (activity.canEdit) {
                <div class="flex gap-2 justify-center">
                  <app-icon-button [icon]="icons.solid.faCheck" (click)="completeActivity(activity)" pTooltip="Complete" tooltipPosition="bottom"></app-icon-button>
                  <app-icon-button [icon]="icons.ppmSolid.edit" (click)="editActivity(activity)" pTooltip="Edit" tooltipPosition="bottom"></app-icon-button>
                  <app-icon-button [icon]="icons.ppmSolid.delete" (click)="deleteActivityClick(activity)" pTooltip="Delete" tooltipPosition="bottom"></app-icon-button>
                </div>
              } @else {
                n/a
              }
            <!-- @for (col of columns(); track col.field) {
              @if (col.field === 'priority') {
                <td>
                  @if (activity.priority === 'High') {
                    <span class="label label-danger"><i class="pi pi-exclamation-triangle"></i></span>
                  }
                </td>
              } @else if (col.field === 'groupName') {
                <td>
                  <a href="{{activity.custId | contactCardUrl}}" target="_blank">
                    {{activity.groupName}}
                  </a>
                </td>
              } @else if (col.field === 'phone') {
                <td><a [href]="'tel:' + activity.phone">{{activity.phone}}</a></td>
              } @else if (col.field === 'canEdit') {
                <td class="text-center">
                  @if (activity.canEdit) {
                    <div class="flex gap-2 justify-center">
                      <p-button icon="pi pi-check" styleClass="p-button-success p-button-sm" pTooltip="Complete" tooltipPosition="bottom"></p-button>
                      <p-button icon="pi pi-pencil" styleClass="p-button-info p-button-sm" pTooltip="Edit" tooltipPosition="bottom"></p-button>
                      <p-button icon="pi pi-trash" styleClass="p-button-danger p-button-sm" pTooltip="Delete" tooltipPosition="bottom"></p-button>
                    </div>
                  } @else {
                    n/a
                  }
                </td>
              } @else {
                <app-table-column [column]="col" [data]="activity"></app-table-column>
              }
            } -->
          </tr>
        </ng-template>
      </p-table>
    }
  }
</p-card> 